import { zones } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Zones() {
  return (
    <section id="zones" className="bg-background-100/70">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="分区广场"
          title="讨论分区，各找各的瓜"
          desc="厚运营的分区结构，让你更快定位想聊的圈子。八卦、时事、剧综与生活都自成一片，互不串味。"
          action={
            <a
              href="#faq"
              className="inline-flex items-center whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-800"
            >
              了解社区规则
              <i className="ri-arrow-right-line ml-1"></i>
            </a>
          }
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {zones.map((z) => (
            <a
              key={z.name}
              href="#feed"
              className="group flex flex-col rounded-xl border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-accent-300/70 hover:bg-accent-50/40"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary-100 text-xl text-secondary-700 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                  <i className={z.icon}></i>
                </span>
                <i className="ri-arrow-right-up-line text-lg text-foreground-300 transition-colors group-hover:text-accent-600"></i>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{z.name}</h3>
              <p className="mt-1.5 flex-1 text-sm leading-relaxed text-foreground-600">{z.desc}</p>
              <div className="mt-4 flex items-center gap-4 border-t border-background-200/70 pt-3.5 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-quill-pen-line text-accent-600"></i>
                  {z.topics}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-user-3-line"></i>
                  {z.members}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}